/* eslint-disable @typescript-eslint/no-explicit-any */
// store/combineSlices.ts
import { StateCreator } from "zustand";

/**
 * Combine multiple slices into a single Zustand store.
 *
 * Strongly typed for the store state (T)
 * Middleware like persist/devtools is inferred per slice
 */
export const combineSlices =
  <T>() =>
  (...slices: StateCreator<T, any, any, Partial<T>>[]): StateCreator<T> =>
  (set, get, api) =>
    slices.reduce(
      (acc, slice) => ({ ...acc, ...slice(set, get, api) }),
      {} as T
    );
